/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileShareCreateResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfFileShareResponseFromDiscriminatorValue, serializeFileShareCreateResponse, serializeShareCreateRequest, type FileShareCreateResponse, type HttpValidationProblemDetails, type IError, type PaginatedResultOfFileShareResponse, type ShareCreateRequest } from '../../../models/index.js';
// @ts-ignore
import { type WithShareItemRequestBuilder, WithShareItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/shares
 */
export interface SharesRequestBuilder extends BaseRequestBuilder<SharesRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.files.item.shares.item collection
     * @param shareId Unique identifier of the item
     * @returns {WithShareItemRequestBuilder}
     */
     byShareId(shareId: Guid) : WithShareItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfFileShareResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<SharesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfFileShareResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileShareCreateResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: ShareCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileShareCreateResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SharesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ShareCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface SharesRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const SharesRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/shares{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SharesRequestBuilderNavigationMetadata: Record<Exclude<keyof SharesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byShareId: {
        requestsMetadata: WithShareItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["shareId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SharesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SharesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfFileShareResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: SharesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileShareCreateResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeShareCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
